import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { deleteMachinePart } from '@/apis/machinePart'
import UpdateMachinePartForm, { UpdateMachinePartFormValue } from '@/components/pages/MachineParts/Update/Form'
import UpdateMachinePartPageHeader from '@/components/pages/MachineParts/Update/PageHeader'
import routes from '@/constants/routes'
import { MachinePart } from '@/types'

import { useGetMachinePart, useUpdateMachineParts } from './update.hooks'

const UpdateMachinePart = () => {
  const { id, machineId } = useParams<{ id: string; machineId: string }>()

  const navigate = useNavigate()

  const { updateMachinePart, loading: updateLoading } = useUpdateMachineParts()
  const { getMachinePart, loading: getLoading, response: getMachinePartResponse } = useGetMachinePart()

  const machinePartId = Number(id)

  const washingMachineId = Number(machineId)

  const handleDeleteMachinePart = async (id: MachinePart['id']) => {
    await deleteMachinePart({ id })
  }

  const handleSubmitForm = async (formValues: UpdateMachinePartFormValue) => {
    await updateMachinePart({
      ...formValues,
      id: machinePartId,
    })
    const path = routes.machineParts.path.replace(':id', washingMachineId.toString())
    navigate(path)
  }

  useEffect(() => {
    getMachinePart({ id: machinePartId })
  }, [getMachinePart, machinePartId])

  return (
    <>
      <UpdateMachinePartPageHeader washingMachineId={washingMachineId} />
      <UpdateMachinePartForm
        {...{ washingMachineId, updateLoading, getLoading, getMachinePartResponse, machinePartId }}
        onSubmit={handleSubmitForm}
        onDelete={handleDeleteMachinePart}
      />
    </>
  )
}

UpdateMachinePart.displayName = 'UpdateMachinePart'
export default UpdateMachinePart
